<template>
<div class="Product">
    <div class="Product__hover-container">
        <div @click="openModal()" v-show="totalVariant == 1 || isClothes || isOnDemand" class="Product__image-container">
            <img class="Product__image" v-if="totalVariant > 1 && !isClothes" :src="product | getProductVariantImage(selectedVariant)">
            <img v-else class="Product__image" :src="product | getProductImage">
        </div>
        <VueSlickCarousel v-if="totalVariant > 1 && !isClothes && !isOnDemand" @afterChange="afterChangeCarousel"  style="margin-bottom:0px;" class="Product__image-container" :lazyLoad="'progressive'" :adaptiveHeight="false" :draggable="false" :dots="true" :dotsClass="'Product__carousel-dot-container'" :infinite="false" :arrows="false" :slidesToShow="1" :slidesToScroll="1">
        <div @click="openModal()" class="Product__option-container" v-for="variant in product.variants" :key="variant.id" :class="[variant.available == false ? 'Product__option-container--disabled' : '']">
          <img class="Product__image" :src="product | getProductVariantImage(variant.id)">
        </div>
        <template #customPaging="page">
          <div class="Product__carousel-dot" v-bind:style="{'background-color': (colorVariants[page] ? colorVariants[page] : '#fff')}" :class="[page == currentCarouselIndex ? 'Product__carousel-dot--selected':'',product.variants[page].available == false ? 'Product__carousel-dot--disabled' : '']">
           <span v-if="!colorVariants[page]"> {{product.variants[page].title.charAt(0)}} </span>
          </div>
        </template>
        </VueSlickCarousel>
        <button @click="openModal()" class="Product__button" :class="[totalVariant > 1 && !isClothes ? 'Product__button-slider' : '']">view</button>
    </div>
    <!-- <div v-if="totalVariant > 1" class="Product_variant_election">
        <div class="Product__option-container" v-for="option in product.options" :key="option.position">
            <div v-if="!isClothes" class="Product__dot_container">
                <div @click="selectOption(variant.option1)" v-for="(variant, index) in product.variants" :key="variant.id" class="Product__carousel-dot" v-bind:style="{'background-color': (colorVariants[index] ? colorVariants[index] : '#fff')}" :class="[variant.id == selectedVariant ? 'Product__carousel-dot--selected':'',product.variants[index].available == false ? 'Product__carousel-dot--disabled' : '']">
                    <span v-if="!colorVariants[index]"> {{product.variants[index].title.charAt(0)}} </span>
                </div>
            </div>
        </div>
    </div> -->
    <p class="Product__title">{{product.title + selectedVariantTitle}}</p>
    <span class="Product__price">{{product | moneyFormat}}</span>
</div>
</template>

<script>
import Vue from 'vue'
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  props:{
    product:Object,
  },
  data(){
      return{
          chosenOption: "",
          currentCarouselIndex: 0,
      }
  },
    components: {
    VueSlickCarousel
  },
  computed: {
    totalVariant(){
      return this.product.variants.length;
    },
    isClothes(){
      return this.product.tags.includes("Clothes");
    },
    isOnDemand(){
      return this.product.tags.some(x => x.includes("QTYMIN"));
    },
    colorVariants(){
      var tags = this.product.tags.filter(x => x.match(/variant/g) || x.match(/Variant/g));
      if(tags.length > 0){
        var sortedTags = tags.sort();
        return sortedTags.map(x => x.split("-")[1]);
        }
    },
    selectedVariant(){
        var variantId    = 0;
        if(this.product.variants.length > 1){
            var variants = this.product.variants;
            variantId = variants.filter(x => x.option1 == this.selectedOption).map(y => y.id)
            variantId = variantId[0];
        }
        if(!variantId || variantId == 0)
        {
            variantId = this.product.variants[0].id;
        }

        return variantId
    },
    selectedOption(){
        if (this.chosenOption != ""){
            return this.chosenOption
        }
        else {
            return this.product.options[0].values[0]
        }
    },
    selectedVariantTitle(){
        var variantId = this.selectedVariant;
        if(this.product.variants.length > 1){
            var variants = this.product.variants;
            return " - " + variants.find(x => x.id == variantId).title;
        }
        else {
            return ""
        }
    },
  },
  methods:{
    openModal(){
        this.$emit("openmodal", this.product, this.selectedOption);
    },
    selectOption(option){
        this.chosenOption = option;
    },
    afterChangeCarousel(index){
      this.currentCarouselIndex = index;
      this.chosenOption = this.product.variants[index].option1;
    },
  }
};
</script>